(() => {
  if (window.cartTermsAgreementInitialized) return;
  window.cartTermsAgreementInitialized = true;

  const syncCheckoutButton = (form) => {
    if (!form?.matches('[data-cart-terms-form]')) return;

    const checkbox = form.querySelector('[data-cart-terms-checkbox]');
    const checkoutButton = form.querySelector('button[name="checkout"]');
    if (!checkbox || !checkoutButton) return;

    checkoutButton.disabled = !checkbox.checked;
    checkoutButton.setAttribute('aria-disabled', checkbox.checked ? 'false' : 'true');
  };

  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-cart-terms-checkbox]')) return;
    syncCheckoutButton(event.target.closest('form'));
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest?.('[data-cart-terms-form]');
    if (!form) return;

    const checkbox = form.querySelector('[data-cart-terms-checkbox]');
    if (checkbox?.checked) return;

    event.preventDefault();
    checkbox?.focus();
  });

  document.addEventListener('cart-drawer:refreshed', (event) => {
    syncCheckoutButton(event.target.querySelector('[data-cart-terms-form]'));
  });

  const initialize = () => {
    document.querySelectorAll('[data-cart-terms-form]').forEach(syncCheckoutButton);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
